
/*
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class ContentViewDomAPI
 * @hideconstructor
 * @classdesc API class that is used to access the content view dom
 */
define([], () => {
	class ContentViewDomAPI {

		/**
		 * @function ContentViewDomAPI#cloneNode
		 * @description Clone and return the dom node used by the view
		 * @return {Node} dom node
		 */
		cloneNode() {}

		/**
		 * @function ContentViewDomAPI#getNode
		 * @description Return the dom node used by the view
		 * @return {Node} dom node
		 */
		getNode() {}

		/**
		 * @function ContentViewDomAPI#getBoundingClientRect
		 * @description Return the client rectangle of the dom node used by the content view
		 * @return {Object} clientRect
		 * @return {Number} clientRect.top
		 * @return {Number} clientRect.left
		 * @return {Number} clientRect.bottom
		 * @return {Number} clientRect.right
		 * @return {Number} clientRect.height
		 * @return {Number} clientRect.width
		 */
		getBoundingClientRect() {}
	}


	return ContentViewDomAPI;
});
